import { render, staticRenderFns } from "./mainCanvas.vue?vue&type=template&id=68604b6f&scoped=true&"
import script from "./mainCanvas.vue?vue&type=script&lang=js&"
export * from "./mainCanvas.vue?vue&type=script&lang=js&"
import style0 from "./mainCanvas.vue?vue&type=style&index=0&id=68604b6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68604b6f",
  null
  
)

export default component.exports